<script>
export default {
  name: "base-servies",
  inject: [
    "personRelationRepository",
    "personJobExperienceRepository",
    "personLicenseRepository",
    "personRelationCodeRepository",
  ],
  data() {
    return {
      relations: [],
      data: [],
    };
  },

  methods: {
    async findPersonRelation(code, id) {
      try {
        const response = await this.personRelationRepository.find(code, id);
        let data = response.data.data;
        this.data = data;
        if (Object.keys(data).length > 0) {
          this.relations = [response.data.data].map((x) => {
            let related_to = x && x.related_to;
            let mobile =
              x &&
              x.related_to &&
              related_to.contacts &&
              related_to.contacts.find((z) => z.kind && z.kind.id == 1);
            let email =
              x &&
              x.related_to &&
              related_to.contacts &&
              related_to.contacts.find((z) => z.kind && z.kind.id == 3);
            let addresses =
              x &&
              x.related_to &&
              related_to.addresses &&
              related_to.addresses.find((z) => z.kind && z.kind.id == 1);
            let relationship = x.meta_data && x.meta_data.relationship_with_you;
            let gender_id =
              x && x.related_to && x.related_to.gender_id
                ? x.related_to.gender_id
                : null;
            return {
              code:
                x && x.related_to && x.related_to.code
                  ? x.related_to.code
                  : null,
              name:
                x && x.related_to && x.related_to.name
                  ? x.related_to.name
                  : null,
              national_code:
                x.related_to && x.related_to.national_code
                  ? x.related_to.national_code
                  : null,
              family:
                x && x.related_to && x.related_to.family
                  ? x.related_to.family
                  : null,
              mobile: mobile && mobile.content ? mobile.content : null,
              email: email && email.content ? email.content : null,
              relationship_with_you:
                this.relationship_options &&
                this.relationship_options.find((x) => x.value == relationship)
                  ? this.relationship_options.find(
                      (x) => x.value == relationship
                    )
                  : null,
              birth_date:
                x.meta_data && x.meta_data.birth_date
                  ? x.meta_data.birth_date
                  : null,
              date_separation_death:
                x.meta_data && x.meta_data.date_separation_death
                  ? x.meta_data.date_separation_death
                  : null,
              date_marriage:
                x.meta_data && x.meta_data.date_marriage
                  ? x.meta_data.date_marriage
                  : null,
              date_death:
                x.meta_data && x.meta_data.date_death
                  ? x.meta_data.date_death
                  : null,
              gender_selected:
                this.gender_options &&
                this.gender_options.find((y) => y.value == gender_id)
                  ? this.gender_options.find((y) => y.value == gender_id)
                  : null,
              regional_municipality:
                addresses && addresses.zone_number
                  ? addresses.zone_number
                  : null,
              description: x.description ? x.description : null,
              address:
                x.meta_data && x.meta_data.address ? x.meta_data.address : null,
              location_selected: {
                id:
                  addresses && addresses.location.id
                    ? addresses.location.id
                    : null,
                caption:
                  addresses && addresses.location.full_path
                    ? addresses.location.full_path
                    : null,
              },
              ...x,
            };
          });
        }
      } catch (error) {
        this.$generateError(error);
      }
    },
    async getPersonRelation(code, relation_type, id) {
      try {
        let params = {
          id: id,
          relation_type_id: relation_type,
        };

        const response = await this.personRelationRepository.list(code, params);
        let data = response.data.data;
        this.data = data;
        if (data.length > 0) {
          this.relations = response.data.data.map((x) => {
            let related_to = x && x.related_to;
            let mobile =
              x &&
              x.related_to &&
              related_to.contacts &&
              related_to.contacts.find((z) => z.kind && z.kind.id == 1);
            let email =
              x &&
              x.related_to &&
              related_to.contacts &&
              related_to.contacts.find((z) => z.kind && z.kind.id == 3);
            let addresses =
              x &&
              x.related_to &&
              related_to.addresses &&
              related_to.addresses.find((z) => z.kind && z.kind.id == 1);
            let relationship = x.meta_data && x.meta_data.relationship_with_you;
            let gender_id =
              x && x.related_to && x.related_to.gender_id
                ? x.related_to.gender_id
                : null;
            return {
              code:
                x && x.related_to && x.related_to.code
                  ? x.related_to.code
                  : null,
              name:
                x && x.related_to && x.related_to.name
                  ? x.related_to.name
                  : null,
              national_code:
                x.related_to && x.related_to.national_code
                  ? x.related_to.national_code
                  : null,
              family:
                x && x.related_to && x.related_to.family
                  ? x.related_to.family
                  : null,
              mobile: mobile && mobile.content ? mobile.content : null,
              email: email && email.content ? email.content : null,
              relationship_with_you:
                this.relationship_options &&
                this.relationship_options.find((x) => x.value == relationship)
                  ? this.relationship_options.find(
                      (x) => x.value == relationship
                    )
                  : null,
              birth_date:
                x.meta_data && x.meta_data.birth_date
                  ? x.meta_data.birth_date
                  : null,
              date_separation_death:
                x.meta_data && x.meta_data.date_separation_death
                  ? x.meta_data.date_separation_death
                  : null,
              date_marriage:
                x.meta_data && x.meta_data.date_marriage
                  ? x.meta_data.date_marriage
                  : null,
              date_death:
                x.meta_data && x.meta_data.date_death
                  ? x.meta_data.date_death
                  : null,
              gender_selected:
                this.gender_options &&
                this.gender_options.find((y) => y.value == gender_id)
                  ? this.gender_options.find((y) => y.value == gender_id)
                  : null,
              regional_municipality:
                addresses && addresses.zone_number
                  ? addresses.zone_number
                  : null,
              description: x.description ? x.description : null,
              address:
                x.meta_data && x.meta_data.address ? x.meta_data.address : null,
              location_selected: {
                id:
                  addresses && addresses.location.id
                    ? addresses.location.id
                    : null,
                caption:
                  addresses && addresses.location.full_path
                    ? addresses.location.full_path
                    : null,
              },
              ...x,
            };
          });
        }
      } catch (error) {
        this.$generateError(error);
      }
    },
    async putPersonRelation(payload, id = null) {
      try {
        const response = await this.personRelationCodeRepository.partial_edit(
          id,
          payload
        );
        return true;
      } catch (error) {
        this.$generateError(error);
        return false;
      }
    },
  },
};
</script>
